import React, { useState, useEffect } from "react";
import WishlistDrawer from "../../common/cartpage/WishlistDrawer";
import { useMenu } from "../../context/MenuContext"; 
import axios from "axios";
import Swal from "sweetalert2";

const Footer = () => {
  const [wishlistOpen, setWishlistOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { menuSettings } = useMenu();
  const [settings, setSettings] = useState({
    logo: "/images/bird.png",
    favicon: "",
    footer_text: "",
    email: "coordinator@tyka.com",
    phone: "+91-98030 61407",
    facebook_url: "#",
    twitter_url: "#",
    instagram_url: "#",
    linkedin_url: "#",
    youtube_url: "#",
    meta_site_name: "",
    meta_description: "",
    meta_keyword: "",
  });

useEffect(() => {
  if (!menuSettings) return;

  setSettings((prev) => ({
    ...prev,
    logo: menuSettings.logo || prev.logo,
    favicon: menuSettings.favicon || prev.favicon,
    footer_text: menuSettings.footer_text || prev.footer_text,
    email: menuSettings.email || prev.email,
    phone: menuSettings.phone || prev.phone,
    facebook_url: menuSettings.facebook_url || prev.facebook_url,
    twitter_url: menuSettings.twitter_url || prev.twitter_url,
    instagram_url: menuSettings.instagram_url || prev.instagram_url,
    linkedin_url: menuSettings.linkedin_url || prev.linkedin_url,
    youtube_url: menuSettings.youtube_url || prev.youtube_url,
    meta_site_name:
      menuSettings.meta_site_name || prev.meta_site_name,
    meta_description:
      menuSettings.meta_description || prev.meta_description,
    meta_keyword:
      menuSettings.meta_keyword || prev.meta_keyword,
  }));
}, [menuSettings]);;

  const handleSubscribe = async () => {
    if (!email) {
      Swal.fire("Oops!", "Please enter your email.", "warning");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        "https://tyka.premierhostings.com/beta/api/subscribers",
        { email }
      );

      if (response.status === 200 || response.status === 201) {
        Swal.fire("Thank you!", "You have successfully subscribed.", "success");
        setEmail(""); // clear input
      } else {
        Swal.fire("Oops!", "Something went wrong. Please try again.", "error");
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Subscription failed.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-black text-white">
      {/* Newsletter Section */}
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-8">
        {/* Left: Newsletter */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            Get our emails for info on
            <br />
            new items, sales and more.
          </h2>
          <p className="mb-4">Subscribe Now</p>
          <div className="flex w-full max-w-lg">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="w-full px-4 py-2 rounded-l-md text-black bg-white border border-white placeholder-gray-400 focus:outline-none"
            />
            <button
              onClick={handleSubscribe}
              disabled={loading}
              className="bg-black text-white px-6 py-2 rounded-r-md border border-white hover:bg-gray-900"
            >
              {loading ? "Subscribing..." : "Subscribe"}
            </button>
          </div>
          <p className="text-[10px] text-gray-400 mt-2">
            By subscribing you agree to our Terms & Conditions and Privacy
            Policy
          </p>
        </div>

        {/* Right: Help */}
        <div className="md:text-left" style={{ marginLeft: "20%" }}>
          <h3 className="text-xl font-semibold">Need help?</h3>
          <p className="text-lg font-medium my-2">+{settings.phone}</p>
          <p className="text-sm">We are available 10:00 am – 6:00 pm</p>
          <div className="flex md:justify-start mt-4 space-x-3">
            <a
              href={settings.facebook_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/icons/fb.svg" alt="FB" className="w-6 h-6" />
            </a>
            <a
              href={settings.instagram_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/icons/instagram.svg" alt="IG" className="w-6 h-6" />
            </a>
            <a
              href={settings.youtube_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/icons/youtube.svg" alt="YT" className="w-6 h-6" />
            </a>
            <a
              href={settings.twitter_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/icons/twitter.svg" alt="X" className="w-6 h-6" />
            </a>
          </div>
          <p className="mt-2 text-sm">TYKA Social · Keep In Touch</p>
        </div>
      </div>

      {/* White Lower Footer */}
      <div className="bg-white text-black py-10 px-6 border-t">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-6 gap-10 text-sm">
          {/* Column 1-2: Logo & Address */}
          <div className="md:col-span-2">
            <img src={settings.favicon} alt="Logo" className="w-12 mb-4" />
            <p
              className="leading-6 overflow-hidden text-ellipsis max-h-24"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 4, // limits to 4 lines
                WebkitBoxOrient: "vertical",
              }}
            >
              {settings.footer_text}
            </p>

            <p className="mt-1">{settings.email}</p>
            <p>+{settings.phone}</p>
          </div>

          {/* Column 3: Information */}
          <div>
            <h4
              className="font-semibold mb-2"
              style={{ fontWeight: "600", fontSize: "1rem" }}
            >
              Information
            </h4>
            <ul className="space-y-1 mt-4">
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/privacypolicy">Privacy Policy</a>
              </li>
              <li>
                <a href="/deliveryreturnpolicy">Delivery and Returns Policy</a>
              </li>
              <li>
                <a href="/termsandconditions">Terms and Conditions</a>
              </li>
              <li>
                <a href="/catalogue">Catalogue</a>
              </li>
            </ul>
          </div>

          {/* Column 4: Customer Support */}
          <div>
            <h4
              className="font-semibold mb-2"
              style={{ fontWeight: "600", fontSize: "1rem" }}
            >
              Customer Support
            </h4>
            <ul className="space-y-1 mt-4">
              <li>
                <a href="/sizechart">Size Chart</a>
              </li>
              <li>
                <a href="#">Fit Guide</a>
              </li>
              <li>
                <a href="blogs">Blog</a>
              </li>
              <li>
                <a href="/fabricguide">Fabric Guide</a>
              </li>
              <li>
                <a href="/frequently-asked-questions">FAQ</a>
              </li>
              <li>
                <a href="/contact">Contact us</a>
              </li>
            </ul>
          </div>

          {/* Column 5: Account */}
          <div>
            <h4
              className="font-semibold mb-2"
              style={{ fontWeight: "600", fontSize: "1rem" }}
            >
              Account
            </h4>
            <ul className="space-y-1 mt-4">
              <li>
                <a href="/userdashboard">Dashboard</a>
              </li>
              <li>
                <a href="/userorder">My Orders</a>
              </li>
              <li>
                <button
                  onClick={() => setWishlistOpen(true)}
                  className="w-full text-left"
                >
                  My Wishlist
                </button>
              </li>

              {/* Wishlist Drawer */}
              <WishlistDrawer
                isOpen={wishlistOpen}
                onClose={() => setWishlistOpen(false)}
              />

              <li>
                <a href="/userdashboard">Track My Orders</a>
              </li>
            </ul>
          </div>

          {/* Column 6: Useful Links */}
          <div>
            <h4
              className="font-semibold mb-2"
              style={{ fontWeight: "600", fontSize: "1rem" }}
            >
              Useful Links
            </h4>
            <ul className="space-y-1 mt-4">
              <li>
                <a href="#">Global Dealers</a>
              </li>
              <li>
                <a href="#">Proud Partners</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom Row */}
        <div className="max-w-7xl mx-auto mt-8 pt-4 border-t text-xs flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-4">
            <p>Copyright 2025 © TYKA Sports. All right reserved.</p>
            <img src="/icons/mastercard.svg" alt="MasterCard" className="h-6" />
            <img src="/icons/visa.svg" alt="Visa" className="h-6" />
            <img src="/icons/wallet.svg" alt="Wallet" className="h-5" />
          </div>
          <div className="flex items-center space-x-2 mt-2 md:mt-0">
            <a href="/privacypolicy" className="hover:underline">
              Privacy Policy
            </a>
            <span>|</span>
            <a href="/termsandconditions" className="hover:underline">
              Terms and Conditions
            </a>
            <span>|</span>
            <a href="/deliveryreturnpolicy" className="hover:underline">
              Delivery and Returns Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
